module.exports = new __parcel__URL__("80x80.98933711.webp").toString();